
import Form from './form.jsx';
import React from 'react';
import {Helmet} from 'react-helmet';


class ContactPage extends React.Component {

  render() {

    return (
      <section className="section-contact container">
        <Helmet>
          <title>Contact us</title>
        </Helmet>
        <div className="row">
          <div className="col-sm-12">
            <Form />
          </div>
        </div>
      </section>
    );
  }
}


export default ContactPage;



// WEBPACK FOOTER //
// ./client/pages/main/contact/index.jsx